// extracted by mini-css-extract-plugin
module.exports = {"subprocessors":"Security-module--subprocessors--3DxcC"};